module.exports = "/_next/static/images/01_1749w-3c0c34e88ae9aaedcfff299a6e3be2a3.png";